
import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';


function MyAlert({ message, action }) {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        setOpen(true);
    }, [message]);

    return (

        <Box sx={{ width: '100%' }}>
            <Collapse in={open}>
                <Alert
                    action={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {action}
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        </Box>
                    }
                    sx={{ mb: 2 }}
                >
                    {message || 'Something needs your attention.'}
                </Alert>
            </Collapse>
        </Box>
    );
}

export { MyAlert };
